module.exports = "/static/fonts/Framework7Icons-Regular.589f22d.eot";


//////////////////
// WEBPACK FOOTER
// ./~/framework7-icons/fonts/Framework7Icons-Regular.eot
// module id = 801
// module chunks = 2